import { useEffect, useState } from "react";
import { getLatestAnnouncements } from "../services/announcementService";

export const useLatestAnnouncements = ({
  limit = 2,
  enabled = true,
} = {}) => {
  const [announcements, setAnnouncements] = useState([]);
  const [isLoading, setIsLoading] = useState(enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setAnnouncements([]);
      setIsLoading(false);

      return undefined;
    }

    const controller = new AbortController();

    const loadAnnouncements = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const result = await getLatestAnnouncements({
          limit,
          signal: controller.signal,
        });

        setAnnouncements(
          Array.isArray(result) ? result : []
        );
      } catch (requestError) {
        if (requestError.name !== "AbortError") {
          setError(requestError);
          setAnnouncements([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    loadAnnouncements();

    return () => controller.abort();
  }, [limit, enabled]);

  return {
    announcements,
    isLoading,
    error,
  };
};